import type { FaireProductEntity } from "../../entity_types/product";

export const p_q23wjbkcnn: FaireProductEntity = {
  token: "p_q23wjbkcnn",
  type: "product",
  name: "Melamine Cake Stand with Nathalie Lété Print - Low - Red Kiss Color",
  brandToken: "b_c8yganb0qb",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/51955201289e7242bccd26b70823b255fbb11648524fa242becb18469485ab7e.png",
  galleryImageUrls: [],
  priceDollars: 35.49,
  description:
    "Melamine Cake Stand with Nathalie Lété Print - Low - Red Kiss Color by RICE by RICE. Serve in style for gatherings, parties and everyday moments.\n\nPart of our collaboration with artist Nathalie Lété, featuring whimsical motifs and joyful color palettes. Ideal for serving and plating—weeknight dinners or weekend gatherings. Made of high‑quality melamine: durable, lightweight and easy to clean—perfect for everyday use and outdoor dining.\n\n * Material: Melamine \n * Dimensions: Diameter × Height: 11.61 in × 4.53 in \n * Care: Top-rack dishwasher safe. Not for microwave. ",
  tags: [],
  msrpDollars: 70.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:34.724Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
